import * as t from 'io-ts';
import { CountryDynamicType } from './country';

export const CountriesListDynamicType = t.interface({
    countries: t.array(CountryDynamicType),
});

export type CountriesList = t.TypeOf<typeof CountriesListDynamicType>;
